import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IWindowState } from './window.state';

export const getWindowState = createFeatureSelector<IWindowState>('window');

// No selectors needed as window state is stateless
